import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import { Desktop } from '../../../media'
import { connect } from "react-redux";
import employeeService from '../../../services/Employee.service'

import ComparisonCategory from './ComparisonCategory'
import HowTo from './HowTo'

const Wrapper = styled.div`

    > h2 {
        font-family: Lato-Light;
        font-size: 24px;
        font-weight: normal;

        color: #2B2B2B;
        text-align: left;
        line-height: 28px;
        margin-top: 0;
        margin-bottom: 11px;
    }

    > div {
        width: 100%;
        border: 1px solid #CCCCCC;
        border-radius: 3px;

        // Mobile version.
        @media (max-width: 768px) {

            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            border: none;
        }

        > .header {
            width: 100%;

            // Mobile version.
            @media (max-width: 768px) {
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
            }

            > span.single-broker {
                width: 100%;
                height: 53px;
                display: inline-block;
                text-align: center;

                font-family: Lato-Light;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 53px;
            }


            > span {
                width: 50%;
                height: 53px;
                display: inline-block;
                text-align: center;

                font-family: Lato-Light;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 53px;
            }

            > span.broker {
                border-right: 2px solid white;

                width: -moz-calc(50% - 2px);
                width: -webkit-calc(50% - 2px);
                width: -o-calc(50% - 2px);
                width: calc(50% - 2px);
            }
        }
    }
`

const ScrolledDiv = styled.div`
    height: 1000px;
    overflow-y: auto;
`

class BrokerComparisonTable extends Component {

  render() {
    const { t, categories, brokers } = this.props;

    return (
      <Wrapper>
        <Desktop>
          {
            <HowTo />
          }
          <h2>{t("AvailableBrokers.BrokerComparisonTitle")}</h2>
        </Desktop>
        <div>
          <ScrolledDiv>
            {categories.map((category, index) => <ComparisonCategory key={index} index={index} category={category} brokers={brokers} />)}
          </ScrolledDiv>
        </div>
      </Wrapper>
    )
  }
}

const mapState = state => ({
  categories: employeeService.mapToBrokerComparisonUI(state.static_content.broker_info, false),
  brokers: state.static_content.broker_info.map(broker_entry => broker_entry.broker),
  employee: state.employee
})

export default connect(mapState, null)(withTranslation('translations')(BrokerComparisonTable))
